<template>
  <v-btn
    class="base-button"
    :class="{ 'full-width': fullWidth, shrink }"
    :color="color"
    :disabled="disabled"
    elevation="0"
    :style="{
      height: dense ? smallButtonHeight : largeButtonHeight,
      color: textColor
    }"
    :text="text"
    @click="handleClick"
    :loading="loading"
  >
    <slot />
  </v-btn>
</template>

<script>
import { smallButtonHeight, largeButtonHeight } from "@/sass/variables.scss";

export default {
  name: "BaseButton",
  data() {
    return {
      smallButtonHeight,
      largeButtonHeight
    };
  },
  props: {
    disabled: Boolean,
    color: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false
    },
    shrink: {
      type: Boolean,
      required: false,
      default: false
    },
    textColor: {
      type: String,
      required: false
    }
  },
  methods: {
    handleClick(event) {
      if (!this.loading) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style lang="scss">
.base-button {
  text-transform: none;
  font-weight: bold;

  &.shrink.v-btn:not(.v-btn--round).v-size--default {
    height: auto !important;
    padding: 0.5rem 0.75rem !important;
  }
  i.v-icon {
    font-size: 17px;
  }
  &.hidden {
    visibility: hidden;
  }
  &.full-width {
    width: 100%;
  }
  &.fixed {
    position: fixed;
  }

  @media only screen and (min-width: $mobile-breakpoint) {
    &:not(.shrink) {
      padding: 0 2rem !important;
    }

    &:not(.shrink).narrow-button {
      padding: 0px 10px !important;
      margin-right: 5px;
    }
  }
}
</style>
